import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  nationalAverages: {
    stateSubsidyPerCapita: 23.37,
    revenueFromSubsidiesPercent: 69.3,
    revenueFromRentPercent: 5.5,
    revenueFromOtherPercent: 25.2,
    expensesForSalariesPercent: 59.4,
    expensesOtherPercent: 40.6,
    staffHigherEducationPercent: 48,
    secretariesHigherEducationPercent: 24.1,
    averageInsuranceIncome: 1028,
    chitalishtaNoTrainingPercent: 70,
    chitalishtaPer10kResidents: 5.5,
    chitalishtaPer1kChildrenUnder15: 4,
    chitalishtaPer1kElderly: 2.3,
  },
  benchmarks: {
    excellent: 90,
    good: 70,
    average: 50,
    poor: 30,
  },
  statistics: {
    totalMunicipalities: 265,
    totalChitalishta: 0,
    totalPopulation: 0,
    totalSubsidy: 0,
  },
  loading: false,
  error: null,
};

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setNationalAverages: (state, action) => {
      state.nationalAverages = action.payload;
    },
    setBenchmarks: (state, action) => {
      state.benchmarks = action.payload;
    },
    updateStatistics: (state, action) => {
      state.statistics = { ...state.statistics, ...action.payload };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setNationalAverages,
  setBenchmarks,
  updateStatistics,
  setLoading,
  setError,
  clearError,
} = dataSlice.actions;

export default dataSlice.reducer;